let opener = $('.nav-toggler')
let closer = $('.nav-close')
let overlay = $('.header .overlay')
let nav = $('.header nav')

opener.on('click', function(){
	overlay.addClass('active')
	nav.addClass('active')
})

closer.on('click', function(){
	overlay.removeClass('active')
	nav.removeClass('active')
})
